import { render, staticRenderFns } from "./ScoopDialog.vue?vue&type=template&id=24030857&scoped=true&"
import script from "./ScoopDialog.vue?vue&type=script&lang=ts&"
export * from "./ScoopDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24030857",
  null
  
)

export default component.exports